export default "/images/icon-ai-main.gif?60453b26959981730a983008bc5dfc88";